import nacl from 'tweetnacl';
import { encodeBase64, decodeBase64, encodeUTF8, decodeUTF8 } from 'tweetnacl-util';

// Generate a new key pair for E2E encryption
export function generateKeyPair() {
  const pair = nacl.box.keyPair();
  return {
    publicKey: encodeBase64(pair.publicKey),
    secretKey: encodeBase64(pair.secretKey)
  };
}

// Encrypt a message for a recipient
export function encryptMessage(plaintext, recipientPublicKey, senderSecretKey) {
  const nonce = nacl.randomBytes(nacl.box.nonceLength);
  const messageBytes = decodeUTF8(plaintext);
  const pubKey = decodeBase64(recipientPublicKey);
  const secKey = decodeBase64(senderSecretKey);

  const encrypted = nacl.box(messageBytes, nonce, pubKey, secKey);
  return {
    encryptedContent: encodeBase64(encrypted),
    nonce: encodeBase64(nonce)
  };
}

// Decrypt a message from a sender
export function decryptMessage(encryptedContent, nonce, senderPublicKey, recipientSecretKey) {
  try {
    const encrypted = decodeBase64(encryptedContent);
    const nonceBytes = decodeBase64(nonce);
    const pubKey = decodeBase64(senderPublicKey);
    const secKey = decodeBase64(recipientSecretKey);

    const decrypted = nacl.box.open(encrypted, nonceBytes, pubKey, secKey);
    if (!decrypted) return null;
    return encodeUTF8(decrypted);
  } catch {
    return null;
  }
}

// Store/retrieve keys from sessionStorage (cleared when tab closes)
const KEY_STORAGE = 'gl_chat_keys';

export function storeKeyPair(roomId, keyPair) {
  const keys = JSON.parse(sessionStorage.getItem(KEY_STORAGE) || '{}');
  keys[roomId] = keyPair;
  sessionStorage.setItem(KEY_STORAGE, JSON.stringify(keys));
}

export function getKeyPair(roomId) {
  const keys = JSON.parse(sessionStorage.getItem(KEY_STORAGE) || '{}');
  return keys[roomId] || null;
}
